// 공지사항 관리(시안 v6 #pg-notice, 계약 §8 — 대표 전용).
import { useCallback, useEffect, useRef, useState } from "react";
import AdminGate from "../../v6common/AdminGate";
import { showToast } from "../../../utill/utill";
import { PAGE, listNotices, getNoticeSummary, deleteNotice, errorText } from "./api";
import { STATUS_TABS, sortNotices } from "./noticeView";
import NoticeList from "./NoticeList";
import NoticeModal from "./NoticeModal";
import "./notice.css";

function savedText(n, isNew) {
    if (!isNew) return "공지를 수정했습니다.";
    const base = n?.is_important ? "중요 공지를 등록했습니다. 게시 기간에 키오스크 진입 시 팝업으로 뜹니다." : "일반 공지를 등록했습니다.";
    if (!n?.push_requested) return base;
    return `${base} ${n.status === "scheduled" ? "게시 시작 시각에 앱 푸시를 보냅니다." : "앱 푸시를 보냅니다."}`;
}

function NoticeBoard() {
    const [status, setStatus] = useState("all");
    const [qInput, setQInput] = useState("");
    const [q, setQ] = useState("");
    const [rows, setRows] = useState([]);
    const [more, setMore] = useState(false);
    const [summary, setSummary] = useState(null);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState("");
    const [modal, setModal] = useState(null); // null | { notice }
    const seq = useRef(0);

    const load = useCallback(async (offset = 0) => {
        const my = ++seq.current;
        setLoading(true); setErr("");
        try {
            const [list, sum] = await Promise.all([
                listNotices({ status, q, offset }),
                offset ? Promise.resolve(null) : getNoticeSummary().catch(() => null),
            ]);
            if (my !== seq.current) return;
            setRows((old) => (offset ? [...old, ...list] : list));
            setMore(list.length >= PAGE);
            if (sum) setSummary(sum);
        } catch (e) {
            if (my === seq.current) setErr(errorText(e));
        } finally {
            if (my === seq.current) setLoading(false);
        }
    }, [status, q]);

    useEffect(() => { load(0); }, [load]);
    useEffect(() => {
        const t = setTimeout(() => setQ(qInput.trim()), 300);
        return () => clearTimeout(t);
    }, [qInput]);

    async function remove(n) {
        try {
            await deleteNotice(n.id);
            showToast("공지를 삭제했습니다.");
            load(0);
        } catch (e) {
            showToast(errorText(e), "error");
        }
    }

    function saved(n, isNew) {
        setModal(null);
        showToast(savedText(n, isNew));
        load(0);
    }

    const count = (key) => (summary ? summary[key] ?? 0 : "-");
    const current = STATUS_TABS.find((t) => t.code === status);

    return (
        <section id="pg-notice">
            <div className="top">
                <div><h1>공지사항 관리</h1><p>중요 공지는 키오스크 진입 시 팝업으로, 일반 공지는 공지사항 메뉴에서 노출됩니다</p></div>
                <div className="top-act"><div className="mini" id="noticeMini">
                    <div>전체<b>{count("total")}</b></div><div>게시중<b>{count("active")}</b></div>
                    <div>예약<b>{count("scheduled")}</b></div><div>만료<b style={{ color: "var(--tx3)" }}>{count("expired")}</b></div>
                </div></div>
            </div>
            <div className="panel">
                <div className="pn-h"><h3>공지사항 목록</h3><span className="tag tag-res">{count(current.key)}건</span><span className="sp"></span>
                    <input className="inp" placeholder="제목 · 내용 검색" style={{ width: 220 }} value={qInput} onChange={(e) => setQInput(e.target.value)} />
                    <button className="btn btn-pri btn-sm" onClick={() => setModal({ notice: null })}><i className="fa-solid fa-plus"></i>공지사항 추가</button></div>
                <div className="tabs" role="tablist">
                    {STATUS_TABS.map((t) => (
                        <button key={t.code} role="tab" aria-selected={status === t.code} className={`tab${status === t.code ? " on" : ""}`}
                            onClick={() => setStatus(t.code)}>{t.label} <span className="nt-cnt">{count(t.key)}</span></button>
                    ))}
                </div>
                {err ? (
                    <div className="empty"><div>{err}</div>
                        <button className="btn btn-sm" style={{ marginTop: 10 }} onClick={() => load(0)}><i className="fa-solid fa-rotate"></i>다시 시도</button></div>
                ) : rows.length === 0 ? (
                    <div className="empty">{loading ? "불러오는 중…" : "공지사항이 없습니다."}</div>
                ) : (
                    <>
                        <NoticeList rows={sortNotices(rows)} onEdit={(n) => setModal({ notice: n })} onDelete={remove} />
                        {more ? <div className="nt-more"><button className="btn btn-sm" disabled={loading} onClick={() => load(rows.length)}>더 보기</button></div> : null}
                    </>
                )}
            </div>
            {modal ? <NoticeModal notice={modal.notice} onClose={() => setModal(null)} onSaved={saved} /> : null}
        </section>
    );
}

export default function NoticePage({ go }) {
    return <main className="inq-r"><AdminGate ownerOnly>{() => <NoticeBoard go={go} />}</AdminGate></main>;
}
